import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"arrow-left\">\n  <polygon points=\"65.53 27.27 34.47 46.1 34.47 53.99 65.53 72.73 65.53 61.28 45.07 50.09 45.07 49.91 65.53 38.72\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol